import { createSelector } from '@reduxjs/toolkit'

export const walletAddressSelector = createSelector(
  (state: AppState) => state.buyer.address,
  (value) => value
)

export const firstNameSelector = createSelector(
  (state: AppState) => state.buyer.firstName,
  (value) => value
)

export const lastNameSelector = createSelector(
  (state: AppState) => state.buyer.lastName,
  (value) => value
)

export const emailSelector = createSelector(
  (state: AppState) => state.buyer.email,
  (value) => value
)
